import { graphql } from '@api/generated';
import { getClient } from '@api/client';

export const getCampaignByPhoneQuery = graphql(`
  query getCampaignByPhone($tenantId: ID!, $phoneNumber: String) {
    campaigns(tenantId: $tenantId, where: { phoneNumber: $phoneNumber }) {
      items {
        id
        name
      }
    }
  }
`);

export type Campaign = {
  id: string;
  name: string;
};

export const getCampaign = async ({
  tenantId,
  phoneNumber,
}: {
  tenantId: string;
  phoneNumber?: string;
}): Promise<Campaign | null> => {
  const { data, error } = await getClient().query({
    query: getCampaignByPhoneQuery,
    variables: {
      tenantId,
      phoneNumber,
    },
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.campaigns?.items?.length && data?.campaigns?.items?.length > 0
    ? data?.campaigns.items[0]
    : null;
};
